import { ITrackingPageExtraRecommendations, TTrackingPlacementType } from '../../types/tracking';
import { EDealType } from '../jsonQuery';

const DEAL_TYPE_MAP: Partial<Record<EDealType, TTrackingPlacementType>> = {
  [EDealType.Sale]: 'sale',
  [EDealType.RentLongterm]: 'rent_long',
  [EDealType.RentDaily]: 'rent_daily',
};

interface IParams {
  dealType: EDealType;
  queryString?: string;
  withEntrSource?: boolean;
}

export const getPageExtra = (extra: IParams): ITrackingPageExtraRecommendations => {
  const placementType = DEAL_TYPE_MAP[extra.dealType];
  const entrSource = extra.withEntrSource ? 'lending_main_page' : undefined;

  return {
    lending_main_page: true,
    placement: 'suburban',
    placement_type: placementType,
    querystring: extra.queryString,
    entr_source: entrSource,
  };
};
